import { type ComponentProps, type PropsWithChildren } from "react"
import { useInView } from "react-intersection-observer"

import { ProductList } from "@unlikelystudio/react-ecommerce-hooks"

import type { CollectionNavigation } from "~/components/ui/AlgoliaCollectionGrid/AlgoliaListingGrid/AlgoliaCollectionToolbar/CollectionNavigation"
import { AlgoliaCollectionToolbar } from "~/components/ui/AlgoliaCollectionGrid/AlgoliaListingGrid/AlgoliaCollectionToolbar/index.client"
import { useGridLayoutContext } from "~/providers/GridLayoutProvider/index.client"

import { sprinkles } from "~/styles/sprinkles.css"

import { layoutGrid } from "../styles.css"

export type AlgoliaListingGridProps = {
  collectionName?: string
  collectionHandle?: string
  isEmpty?: boolean
} & Pick<ComponentProps<typeof CollectionNavigation>, "collectionNavigationLinks">

export function AlgoliaListingGrid({
  children,
  collectionName,
  collectionNavigationLinks,
  isEmpty,
}: PropsWithChildren<AlgoliaListingGridProps>) {
  const { layout } = useGridLayoutContext()

  const [gridRef, gridRefInView] = useInView({
    initialInView: false,
    threshold: 0,
    rootMargin: "-10% 0px 100% 0px",
  })

  return (
    <div className={sprinkles({ position: "relative" })}>
      <AlgoliaCollectionToolbar
        isGridInView={gridRefInView}
        collectionNavigationLinks={collectionNavigationLinks}
        isEmpty={isEmpty}
      />
      <ProductList listId="page-collection" listName={collectionName}>
        <div ref={gridRef} className={layoutGrid[layout]}>
          {children}
        </div>
      </ProductList>
    </div>
  )
}
